import { useNavigate } from "react-router-dom";

import "@css/temp_configure.css";
import ConfTab1 from "@components/feature/roster_configure/ConfTab1";
import { useIsAdmin } from "@/hooks/useAuth";
import { useInitializeGroup } from "@hooks/useInitializeGroup.ts";
import NoneConfigData from "@pages/roster-config/components/none-configdata.tsx";
import { useGroupStore } from "@store/groupStore.ts";
import useStore from "@store/store.ts";

function Roster_configure() {
  const { loginUser } = useStore();
  const navigate = useNavigate();
  const isAdmin = useIsAdmin();
  const { selectedGroupId } = useGroupStore();
  const { groups } = useInitializeGroup({
    loginUser,
    isAdmin,
    navigate,
  });

  if (isAdmin && Array.isArray(groups) && groups.length === 0) {
    return <NoneConfigData />;
  }

  return (
    <div className="py-10">
      <div className="flex flex-col items-center justify-center gap-10 px-5 pt-5">
        <ConfTab1 isAdmin={isAdmin} selectedGroupId={selectedGroupId} />
      </div>
    </div>
  );
}

export default Roster_configure;
